import React from 'react';
import { useSelector } from 'react-redux';

export const Resource = ({ resource, padBottom }) => {
    resource = {
        type: 'file',
        name: 'Resource name goes here',
        description: 'Resource description goes here',
        url: 'https://www.google.com',
    };

    const buttonText = 'Open';

    return (
        <a href="#" data-testid="course-item" className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}>
            {/* <div className="prism-banner-float flex flex-center">
                <Bullet type="resource" />
            </div> */}
            <div className="prism-content">
                <small>{resource.type}</small>
                <h3>{resource.name}</h3>
                {resource?.description && <p className="truncate-4">{resource.description}</p>}
                <button className="btn btn-primary" onClick={() => console.log('CLICKED')}>
                    {buttonText}
                </button>
            </div>
        </a>
    );
};

export default Resource;
